import TrackProAPI from './track-pro-api'

export const getPartLookup = (serial_num: string) => {
    const endpoint = `/assets/part-lookup?serial_num=${serial_num}`
    return TrackProAPI.get(endpoint)
}
